/* eslint-disable no-restricted-globals */
import React, { useState, useEffect } from "react"
import { Button } from "semantic-ui-react"
import { apiGet, apiPost } from "../utils/apiConnector"
import { useTranslation } from "react-i18next"
import { invoiceGetDataApi } from "../config/apiUrls"
import { encode, decode } from "js-base64"

const optionsM = [{ key: 0, value: "PKCS12", text: "PKCS12" }]

const webSocket = new WebSocket("wss://127.0.0.1:13579/")
let callback = null

const SignXml = (props) => {
  const { t } = useTranslation()
  const { getXmlData, sendData, data, uuid, token, setToken } = props
  const [btXml, setBtXml] = useState("")
  const [authData, setAuthData] = useState("")
  const openDialog = () => {
    if (
      confirm(
        "Ошибка при подключение к NCALayer. Запустите NCALayer и нажмите OK",
      ) === true
    ) {
      location.reload()
    }
  }
  const createCAdESFromBase64Call = (res) => {
    const xts = res
      .replaceAll('<?xml version="1.0" encoding="UTF-8"?>\n', "")
      .replaceAll(
        "<!--Sample XML file generated by XMLSpy v2020 rel. 2 sp1 (x64) (http://www.altova.com)-->\n",
        "",
      )
    const b64tsgn = encode(res)
    setBtXml(b64tsgn)
    const encData = encode(data)
    console.log("data", data)
    console.log("encdata", encData)
    if (encData !== null && encData !== "") {
      // $.blockUI()
      if (token && false) {
        createCAdESFromBase64(
          "PKCS12",
          "SIGNATURE",
          encData,
          false,
          createCAdESFromBase64BackAlt,
        )
      } else {
        createCAdESFromBase64(
          "PKCS12",
          "SIGNATURE",
          encData,
          true,
          createCAdESFromBase64Back,
        )
      }
    } else {
      alert("Нет данных для подписи!")
    }
  }
  const createCAdESFromBase64Back = (result) => {
    // $.unblockUI()
    if (result["code"] === "500") {
      alert(result["message"])
    } else if (result["code"] === "200") {
      const res = result["responseObject"]
      console.log(res)
      const r = decode(res)
      console.log(decode(btXml))
      console.log(r)
      const s = r.replaceAll(data, "")
      console.log(s)
      console.log(encode(s).replaceAll("+/v", ""))
      setAuthData(res)
      const encData = "123aaaaaaa"
      createCAdESFromBase64(
        "PKCS12",
        "SIGNATURE",
        btXml,
        false,
        createCAdESFromBase64BackAlt,
      )
      // sendData(res, btXml, encode(s))
    }
  }
  const createCAdESFromBase64BackAlt = (result) => {
    if (result["code"] === "500") {
      alert(result["message"])
    } else if (result["code"] === "200") {
      const res = result["responseObject"]
      const signature = res
      console.log(signature)
      sendData(authData, btXml, signature)
    }
  }
  const createCAdESFromBase64 = (
    storageName,
    keyType,
    base64ToSign,
    flag,
    callBackM,
  ) => {
    let req = {
      module: "kz.gov.pki.knca.commonUtils",
      method: "createCAdESFromBase64",
      args: [storageName, keyType, base64ToSign, flag],
    }
    callback = callBackM
    webSocket.send(JSON.stringify(req))
  }
  useEffect(() => {
    webSocket.onopen = (event) => {
      //
    }
    webSocket.onclose = (event) => {
      if (event.wasClean) {
        console.log("connection has benn closed")
      } else {
        console.log("Connection error")
        openDialog()
      }
      console.log("Code:" + event.code + " Reason: " + event.reason)
    }
    webSocket.onmessage = (event) => {
      console.log(event)
      let result = JSON.parse(event.data)
      if (result != null) {
        let rw = {
          code: result["code"],
          message: result["message"],
          responseObject: result["responseObject"],
          getResult: () => {
            return this.result
          },
          getMessage: () => {
            return this.message
          },
          getResponseObject: () => {
            return this.responseObject
          },
          getCode: () => {
            return this.code
          },
        }
        if (callback != null) {
          callback(rw)
        }
      }
    }
  }, [])
  return (
    <>
      <div>
        <Button
          positive
          content={t("signWithEcp")}
          onClick={() => {
            getXmlData(createCAdESFromBase64Call)
            // getData()
          }}
        />
      </div>
    </>
  )
}

export default SignXml
